import createFormValidator from "./form-validator";

export * from "./rules";
export * from "./validators";
export * from "./predicates";

export default createFormValidator;
